import React from 'react';
import { Sparkles, Infinity as InfinityIcon } from 'lucide-react';
export function LifetimeAccessBonus() {
  return <div className="mt-8" data-id="element-292">
      <div className="bg-violet-50 rounded-3xl p-6 border-2 border-violet-200 shadow-lg relative overflow-hidden" data-id="element-293">
        <div className="relative z-10 flex flex-col md:flex-row items-center gap-6" data-id="element-294">
          <div className="shrink-0 w-24 md:w-32" data-id="element-295">
            <img src="https://cdn.magicpatterns.com/uploads/q95pnAgWMR4B9QZwBL1Zcx/Diseno_sin_titulo.png" alt="Acceso Vitalicio" className="w-full h-auto drop-shadow-md" data-id="element-296" />
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-297">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-violet-600 text-white text-[9px] font-black uppercase tracking-widest mb-3" data-id="element-298">
              <Sparkles size={10} data-id="element-299" />
              <span data-id="element-300">BONO EXTRA</span>
            </div>

            <h3 className="text-xl md:text-2xl font-black text-violet-950 uppercase italic mb-2 font-[Poppins]" data-id="element-301">
              Acceso <span className="text-violet-600" data-id="element-302">Vitalicio</span>
            </h3>

            <p className="text-violet-900/80 text-sm md:text-base leading-snug mb-3 font-medium" data-id="element-303">
              Un solo pago, acceso de por vida a todo el material y futuras
              actualizaciones. Sin mensualidades.
            </p>

            <div className="flex items-center justify-center md:justify-start gap-2 text-violet-600 font-black uppercase tracking-widest text-[10px]" data-id="element-304">
              <InfinityIcon size={14} data-id="element-305" />
              <span data-id="element-306">INCLUIDO GRATIS</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}